import EventEmitter from 'events'
import * as firebase from "firebase";
import firebaseApp from  "./FirebaseApp";
import cardRepository from './cardRepository'

class stackFunctions extends EventEmitter {
	constructor () {
		super()
		this.ref = firebase.database().ref('stacks')
    this.userRef = firebase.database().ref('users')
    this.cardRef = firebase.database().ref('cards')
	}

	create ({title = '', description = '', slug = '', creator =''}, onComplete) {
      var that = this
	    this.ref.push({title, description, slug, creator}, onComplete).then(function(stack){
        that.userRef.child(creator + '/stacks/'+ stack.key).set(true, onComplete)
        that.ref.child(stack.key).update({created: firebase.database.ServerValue.TIMESTAMP}, onComplete)
        that.userRef.child(creator + '/stackCount').transaction(function(currentCount) {
          return currentCount + 1;
        });

        cardRepository.create({
          title: title,
          description: description,
          url: "/stack/" + slug,
          creator: creator,
          author: creator,
          type: "stack",
          length: 0,
          image: null,
          source: 'stacks',
          snippet: description,
          icon: null,
          show: 'stack',
          stack: null,
          order: null,
          stackCount: null,
          boundStack: stack.key
            },
            (err) => {
              if (err) {
                throw err
              }
        })
      })
	}

  update ({boundCard, key, title = '', description = ''}, onComplete) {
    this.ref.child(key).update({title, description}, onComplete)
    this.cardRef.child(boundCard).update({title, description}, onComplete)
  }

  remove (stack, onComplete) {
    var that = this
    var card
    //get card object through stack.boundCard
    if(stack.boundCard) {
      this.cardRef.child(stack.boundCard).once('value').then(function(snapshot){
        card = snapshot.val()
        card.key = snapshot.key
        cardRepository.remove(card, (err) => {
          
          if (err) throw err  
        })
        that.ref.child(stack.key).remove(onComplete)
      })
    } else {
      this.ref.child(stack.key).remove(onComplete)
    }

  	
    this.userRef.child(stack.creator + '/stacks/' + stack.key).remove(onComplete)
    this.userRef.child(stack.creator + '/stackCount').transaction(function(currentCount) {
      return currentCount - 1;
    });


  }

	attachFirebaseListeners () {
	    this.ref.on('child_added', this.onAdded, this)
	    this.ref.on('child_removed', this.onRemoved, this)
	    this.ref.on('child_changed', this.onChanged, this)
  	}

  	// dettach listeners from Firebase
  	detachFirebaseListeners () {
  	    this.ref.off('child_added', this.onAdded, this)
  	    this.ref.off('child_removed', this.onRemoved, this)
  	    this.ref.off('child_changed', this.onChanged, this)
        this.userRef.off()
        this.cardRef.off()
  	}

	onAdded (snapshot) {
      // process data
      let stack = this.snapshotToStack(snapshot)
      // propagate event outwards with note
      this.emit('added', stack)
   }

   onChanged (snapshot) {
     let stack = this.snapshotToStack(snapshot)
     this.emit('changed', stack)
   }

   onRemoved (oldSnapshot) {
     let stack = this.snapshotToStack(oldSnapshot)
     this.emit('removed', stack)
   }

   snapshotToStack (snapshot) {
      // we will need the key often, so we always want to have the key included in the note
      let key = snapshot.key
      let stack = snapshot.val()
      stack.key = key
      stack.username = null        

      this.userRef.child(stack.creator + '/username').on('value', function(snapshot) {
        stack.username = snapshot.val()
      })

      return stack
     } 


	// Finds the index of the note inside the array by looking for its key
	findIndex (stacks, key) {
	   return stacks.findIndex(stack => stack.key === key)
	 }

	// Finds the note inside the array by looking for its key
	find (stacks, key) {
	    return stacks.find(stack => stack.key === key)
	}
}
export default new stackFunctions()


// WEBPACK FOOTER //
// ./src/data/stackFunctions.js